import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    
    setTimeout(() => {
      this.fixNavbarPosition()
    }, 50)
    
    this.setupTurboListeners()
  }

  fixNavbarPosition() {
    
    const navbar = document.querySelector('nav.fixed')
    if (navbar) {
      navbar.style.setProperty('top', '0px', 'important')
      navbar.style.setProperty('margin-top', '0px', 'important')
      navbar.style.setProperty('padding-top', '0px', 'important')
      
    } else {
    }
  }


  setupTurboListeners() {
    const events = [
      'turbo:frame-load',
      'turbo:frame-render'
    ]

    events.forEach(eventName => {
      document.addEventListener(eventName, (event) => {
        if (event.target && (
          event.target.id === 'content-turbo-frame' ||
          event.target.querySelector('#content-turbo-frame')
        )) {
          
          setTimeout(() => {
            this.fixNavbarPosition()
          }, 100)
        }
      })
    })
  }

  disconnect() {
  }
}